<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>服务协议</span>
    </header-bar>
    <div class="page-content" style="background-color: #FFF;text-align:left;" ref="contractContent">
      <div style="width: 94%; margin: 0 auto;">
        <h2 style="text-align:center;">服务协议</h2>
        <pre>
力程商旅网站由上海力程国际旅行社有限公司运营，涉及具体产品服务的将由有资质的服务商提供。如果您在本网站、力程关联公司网站或其他提供力程商旅服务的移动应用或软件上（以下简称“力程商旅”），访问、预订或使用我们的产品或服务（以上统称为“服务”），便视为用户接受了以下服务协议。您在确认注册前，请您务必审慎阅读、充分理解合同中的相关条款内容，尤其是以下加粗字体部分话术。如果您不同意以下任何内容，请立刻停止访问本网站或使用本网站服务。
一、总则
若您作为力程商旅的注册公司或合作公司的用户登录力程商旅平台，访问力程商旅网站或使用力程商旅服务，即视为您同意本协议的所有条款及力程商旅公布的其他规则、说明和操作指引。本协议由您（或简称“甲方”）与上海力程国际旅行社有限公司（简称“力程商旅”），本着互惠互利的原则，共同缔结。
二、服务简介
力程商旅开放网络、手机客户端、微信服务号、电话、电子邮件等渠道，向甲方提供商务旅行相关的咨询、预订及管理服务，内容包括：国内国际机票；国内国际酒店；火车票；用车；提供管理报告；其他约定的与旅行相关的服务。
机票预订与收费
1. 甲方按“机票价格/套餐价”模式，向力程商旅支付机票费用。
1.1 机票价格是指预订时力程商旅网站、手机APP及线下预订系统内显示的机票实际售卖价格。
1.2 套餐价是指部分由力程及力程优质供应商提供的特价类套餐价格，包括“机票+保险”、 “机票+优惠券”等多种特惠套餐。此类套餐产品不可分开销售，如选择预订则表示接受套餐产品及价格，如不需要可选择其它非套餐类机票产品。
1.3 甲方在力程商旅预订机票时，可使用信用卡支付机票及套餐的费用。
2.团队机票以实际报价为准。
3.根据航空公司要求，某些特殊情况下的机票改签手续可能需至航空公司营业网点，或通过航空公司网站/呼叫中心办理。在此情况下，若甲方委托力程商旅进行代办的，力程商旅收取甲方代办服务费100元/次（不包含航空公司可能收取的机票变更费用）。
4.报销凭证：报销凭证由力程商旅提供，保险部分由保险公司提供定额发票。
酒店预订流程
1. 甲方可选择预付或在酒店前台支付，预付可使用信用卡支付。
2. 报销凭证：前台支付的酒店发票由入住酒店提供；预付的酒店发票由力程商旅提供。
火车票预订与收费
1. 甲方需登录乙方网站或手机APP预订所需火车票电子票。每张车票须支付每张20元服务费（退票时服务费不退）。若需配送纸质票，甲方须再支付5元/张纸质票出票费，以及相应配送费（根据配送地址略有不同，以乙方网站显示为准）。
2.接受预订：进入预售期的车票可做预订服务，受铁路部门客观情况限制，乙方无法承诺百分之百都能预订成功，对此甲方应予以理解。
3. 工作时间：网上预订时间为全天24小时，网上退票时间为9:00-20:00。
4. 甲方预订实名制车票，须提供有效身份证件。按照相关规定，目前可接受的有效身份证件有：身份证（二代）、回乡证、台胞证、护照。
5. 出票：现结订单一经预订，即代表甲方同意出票。
6. 报销凭证：火车票本身具有报销功能，故乙方/丙方不再额外开具发票。服务费、纸质出票费、配送费发票由乙方提供。火车票退票手续费的发票需凭有效乘车人证件原件在办理退票日起10天内自行到火车站售票窗口索取。
7. 退票：电子票未取票且离发车时间大于40分钟可在线办理退票；否则需出行人自行前往火车站退票窗口办理。
8. 改签：乙方仅提供在特定条件下的火车票在线改签服务，具体以网页提示为准。其他不能在线改签的情况需在发车前至火车站窗口办理。
租车的预订和收费
1. 线上预订：
甲方通过乙方网上预订国内接送机/接送火车、马上叫车、国内包车、国内租车、国际租车等产品（以网站显示为准），可使用信用卡支付。
1.1 甲方需登录乙方网站或手机APP预订所需产品，不接受电话预订。
1.2 工作时间：网上预订时间为全天24小时。
1.3 预订的订车服务产品价格，以乙方给到的确认单（邮件、传真或手机短信）上约定的金额为准。
1.4 订车服务产品组成要素，均为经过乙方严格考评筛选出的具备相关资质的供应商提供，乙方对订单中已经确认的用车车型描述和相关服务和承诺承担责任。
1.5 订单生效后，甲方应按订单中约定的有效时间或时段准时到达约定地点。如未在约定时间内到达约定地点则视为主动解约。
1.6 订单生效后，甲方可以在订车服务活动开始前通知乙方取消所做预订，但还需承担乙方处理该订单已经支出的其它必要费用，具体请参照网上公布的产品说明。
1.7 报销凭证： 甲方通过信用卡支付订单，国内用车每单用车完毕后寄送发票，国际用车每单用车完毕后可自行打印Invoice。
2. 线下预订：
2.1 国内代驾租车：
2.1.1 国内代驾租车包括接送机、接送站、包车、日租车、半日租车、特殊行程。
2.1.2 预订至少提前3个工作日，工作时间为周一至周五09:00至18:00（法定节假日不计入工作日）。
2.1.3 租车价格以乙方预订时公布为准，特殊用车安排以乙方的确认为准。
2.1.4 甲方向丙方支付订单所确认的费用，超出部分（如超时、超公里、停车费和过路过桥费）由甲方与司机直接结算。
2.1.5 订单生效后，甲方取消订单可能会产生取消手续费，具体以乙方确认为准。
2.2 国际自驾租车：
2.2.1 预订至少提前5个工作日，工作时间为周一至周五09:00至18:00（法定节假日不计入工作日）。
2.2.2 租车价格具体视用车行程、车型、汇率提供参考报价，最终以乙方的预订确认为准。租车费用由甲方支付给当地租车公司，不适用于月结协议。
2.2.3 国际租车服务费为30元/单。
2.2.4 订单生效后，若甲方取消订单，则退票服务费不退。
2.2.5 订单生效的定义：产品预订成功后即视为订单生效。
2.2.6 订单生效后，甲方应按订单中约定的时间到达约定地点取车。如甲方未在约定时间内到达约定地点则视为甲方主动解约，乙方将依照未按规定取消订单向甲方收取违约金。
2.2.7 报销凭证： 由乙方提供报销凭证, 保险提供由保险公司提供的定额发票。
三、责任义务
1.甲方同意：⑴提供及时、详尽及准确的个人资料。⑵不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。另外，甲方可授权力程商旅向第三方透露其基本资料用于必要服务，但不能公开用户的补充资料。除非：⑴用户要求力程商旅透露这些信息。⑵相应的法律要求及程序要求力程商旅提供用户的个人资料。
2.如果用户提供的资料不准确，或恶意使用力程商旅系统违规操作、非法牟利，力程商旅保留结束用户使用力程商旅服务的权利。
3.用户在享用力程商旅服务的同时，同意接受力程商旅为会员服务提供的各类信息服务，包括但不限于EDM、短信、力程App信息推送、PC端广告等服务类及营销类信息。
4.力程商旅提供服务的义务取决于机票、酒店等产品服务的可供性，而所有这些又取决于价格、限制条件和航空公司或者其他服务供应商的相关条款和条件。
5.力程商旅为甲方提供航空公司、酒店和其他服务供应商的信息咨询和预订服务，力程商旅并不直接拥有或经营航空公司，酒店或者其他运输或与旅行有关的服务产品，因此甲方在使用中如果发生损失应由相关服务产品供应商承担责任，但力程商旅承诺将尽力协助甲方与相关服务供应商进行协调。
6.协议双方都不承担任何由于违反本协议规定或者未接受协议规定提供的服务而给对方造成的非直接损失或间接利益损失。
7.您在享受力程商旅提供的各项服务的同时，授权并同意接受力程向您的电子邮件、手机、通信地址等发送商业信息，包括不限于最新的力程产品信息、促销信息等。若您选择不接受力程提供的各类信息服务，您可以按照力程提供的相应设置拒绝该类信息服务。
四、服务条款的修改
力程商旅会在必要时修改服务条款，如制订、修改本协议及/或各类规则向用户提供基于互联网以及移动网的相关服务的，应在本页面及其相应页面提前公布通知，用户应该定期登录本页面及其他相关页面，了解最新的协议内容。变更后的协议和规则在本页面及相关页面公布后七天，将自动生效。如您不同意相关变更，应当立即停止访问力程商旅或使用力程服务，若用户在网站协议和规则变更七日后继续使用力程商旅服务的，即表示您接受已经修订的协议和规则。
五、不可抗力
1.您完全理解并同意，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此任何因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、GSM网络、互联网络、通信线路等其他力程商旅无法预测或控制的原因，造成服务中断、取消或终止的风险，由此给您带来的损失力程商旅不承担赔偿责任。
2.由于战争、地震、雷击、水灾、火灾、政府行为、黑客攻击、电信部门技术管制等不可抗力原因致使双方不能按约定履行协议，则本协议的履行时间应予以延期，双方均不对因不可抗力造成的损失承担责任。若不可抗力事件致使协议履行延期超过一个月的，本协议任何一方有权书面通知其他协议签署方立即终止本协议而无需承担违约责任。受影响的一方应在不可抗力发生后尽快以传真或电子邮件通知对方，并在有关机关出具证明书后三天内以最快方式向对方提供一切相关材料。
六、用户的帐号，密码和安全性
1.尊重用户个人隐私是力程的一项基本政策。力程网是将有资质的酒店、机票代理机构、旅行社等提供的旅游服务信息汇集于力程网供用户查阅，同时帮助用户通过力程网与上述酒店、机票代理机构、旅行社等联系并预订相关旅游服务项目。用户通过完成注册程序一旦注册成功成为用户，将得到一个密码和帐号,表示用户明确知晓本隐私政策所列事实，并与上海力程国际旅行社有限公司达成协议并接受所有的服务条款。每个用户都要对其帐户中的所有活动和事件负全责。您可随时改变您的密码和图标，也可以结束旧的帐户重开一个新帐户。请您对密码加以妥善保管，切勿将密码告知他人，因密码保管不善而造成的所有损失由您自行承担。您对通过您的账户所进行的活动、行为和事件依法享有权利和承担责任，且不得以任何形式转让账户、授权他人使用您的账户以及与他人交易账户。鉴于网络服务的特殊性，力程商旅无义务审核是否是您本人使用该组用户名及密码，仅审核用户名及密码是否与数据库中保存的一致，任何人只要输入的用户名及密码与数据库中保存的一致，即可凭借该组用户名及密码登陆并使用力程所提供的各类服务，所以即使您认为您的账户登陆行为并非您本人所为，力程商旅网将不承担因此而产生的任何责任。
2.政策的确认和接纳 我们十分注重保护用户的个人信息及隐私安全，我们理解您通过网络向我们提供信息是建立在对我们信任的基础上，我们重视这种信任，也深知隐私对您的重要性，并尽最大努力全力保护您的隐私。如果您对我们的隐私政策有任何的疑问或建议，请联系：op001@lchtrip.com。
3.信息收集
3.1为了更好地为您提供服务，力程将遵循“合理、相关、必要”原则，且以您同意为前提收集信息，不会收集法律法规禁止收集的信息。考虑到力程会员服务的重要性，用户同意，力程将会收集您在力程网上输入的或者以其他方式提供给我们的所有信息：
3.1.1在您注册为力程会员时，需提供姓名、性别、生日、手机号、邮箱等信息。
3.1.2在您后续更新个人信息时，需符合及时、详尽、准确的要求。
3.1.3在您预订机票或火车票时，需提供乘客姓名、性别、生日、证件号以及联系人姓名、手机号、邮箱及配送地址等信息。
3.1.4在您预订酒店、景点门票时，需提供入住人姓名、联系人姓名、手机号、邮件等信息。
3.1.5在您购买产品进行支付结算时，需提供银行卡卡号、银行预留手机号、或者信用卡卡号、持卡人姓名、到期日期等信息。
3.1.6我们也可能了解您的旅行计划、风格和喜好，包括膳食要求、出行/入离时间、座位选择、票务选择、保险选择以及力程提供其他服务（如旅游、用车、门票、攻略等）所需要您提供的个人信息。
3.2您可以通过力程为其他人预订，您需要提交该旅客的个人信息，向我们提供该旅客的个人信息之前，您确保您已经取得本人的同意，并确保其已知晓并接受本隐私政策。
3.3我们会从关联公司、业务合作伙伴来源获得您的相关信息。例如当您通过我们关联公司、业务合作伙伴网站及其移动应用软件等预订时，您向其提供的预订信息可能会转交给我们，以便我们处理您的订单，确保您顺利预订。又如，我们允许您使用社交媒体帐号关联我们的帐号进行登录，在您同意的情况下（您授权给该社交平台），您的相关个人信息会通过社交平台分享给我们。
七、保密条款
1.兹就双方之间的合作，双方均承诺并保证其有义务不向非本协议签署方透露保密信息，该保密信息指由签署本协议的一方向其他本协议签署方透露的，与双方合作有关的任何口头或书面形式或其他形式的不公开信息，包括但不限于商业计划、客户名单、技术数据、产品构思、开发计划、职员名单、力程企业商旅账号和密码、操作手册、加工工艺、技术理论、发明创造、财务情况和其他递交时约定为保密信息的资料（以下通称“保密信息”）。
2.对于本协议中描述的保密信息，双方及其代理人、代表应当（1）以不低于保护自己保密信息的程度（至少以合理程度）予以保密；（2）要求获知保密信息的人员对保密信息予以保密；（3）在必要情况下，根据双方书面商定的方式使用保密信息。
3.对于以下信息，双方均免除保密责任：由公众通过合法途径获知的信息；从非本协议签署方获知的，并未违反任何保密责任的信息；为法律或有管辖权的政府部门根据法令所要求透露的信息，或者根据法律程序而要求透露的信息。
4.未经力程商旅事先书面同意，甲方不得将力程商旅的公司商业秘密信息泄露给任何其他第三方，该商业秘密包括但不限于甲方可能接触到的力程商旅公司信息、组织架构、专人组的联系方式和预订卡号等信息。若甲方违反上述保密义务，应当赔偿力程商旅因此遭受到的所有损失。
5.本保密条款不因本协议终止而失效。
八、知识产权
1.力程商旅为用户提供的商业信息。所有这些内容均受版权、商标、标签和其它财产所有权法律的保护。用户只能在力程商旅和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。否则一方有权随时以书面形式通知其他协议签署方终止协议，由侵权行为方承担由此而产生的一切法律责任，并赔偿因此造成的一切损失。
2.双方及其职员承诺在履行本协议期间及在本协议期满后不对对方所拥有的商标、企业名称、域名等进行贬低或者其它任何损害，也不对对方互联网网页或者网站进行任何贬低、抄袭、歪曲、破坏或其它损害。
3.本协议有效期内及本协议终止或者解除后，双方承诺不向任何非本协议签署方（包括但不限于与对方构成商业竞争关系的企业、商业机构或者组织）提供有关双方业务、技术等一切相关信息或者资料，否则由一方承担相应的责任，并赔偿另一方因此造成的一切损失。
4.为确保交易安全，允许力程及其关联公司对用户信息进行数据分析，并允许力程及其关联公司对上述分析结果进行商业利用。
九、禁止贿赂条款
1.任何一方保证不向其他协议签署方及与本合作有关的任何非本协议签署方的雇员或管理、工作人员，直接或间接，在账外暗中支付任何佣金、报酬或给予回扣，或提供任何礼品或款待，亦不向其他协议签署方及与本合作有关的任何非本协议签署方雇员或管理、工作人员就上述事项达成任何安排。按照商业惯例赠送小额广告礼品的除外(力程商旅举报电话86-21-60720584，举报邮箱mailto:jjfw@lichengtrip.net)。
2.若任何一方违反了本条规定，则视为严重违约。守约方有权以书面形式通知违约方单方终止本合同，同时保留依法采取进一步法律措施的权利，违约方应承担由此给守约方带来的一切损失。
十、其他
1.本协议初始有效期为一年。任何一方未在本协议届期前一个月书面通知其他协议签署方终止本协议，则本协议自动延续。
2.协议期间，一方欲变更或终止协议，需提前一个月向对方书面提出，经三方协商一致可变更或终止协议；若三方协商无法达成一致，则本协议自提出终止要求三个月之后终止。若一方未经对方同意，擅自变更或终止本协议，则需赔偿其他协议签署方因此而遭受的经济及声誉损失。
3.甲方应在本协议终止日后三十天内向力程商旅偿付全部的未支付金额。
4.如果一方资不抵债，或被进行清算，或终止经营，或提出破产申请/被提出破产申请，或被宣告破产，或为债权人利益进行转让，或者其他协议方有理由相信或有证据表明其付款能力会受到影响，其他协议签署方均有权通过书面通知立即终止服务而不需承担任何额外责任。
5.合作期间内，双方不得因单位名称的变更或者法定代表人、负责人和承办人等事项的变动而不履行协议所规定的内容。
6.本协议签署后，各方可以签署补充协议或以邮件确认的方式，约定产品、价格、预订流程方面的变更。各方同意，邮件确认的方式同样具有法律效力。
7.本协议适用中华人民共和国法律，如有任何争议，由上海市长宁区人民法院管辖。
8.甲方知晓本协议项下所述的旅行服务将由包括力程商旅和力程商旅的合作伙伴共同提供。
      </pre
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 0.38rem;
  }
  .header-menu header {
    background-color: #12a3ff;
  }
  .page-content {
    top: 2.12rem;
  }
</style>
<script>
  import navBar from "../modules/navBar.vue";
  export default {
    name: "about",
    data() {
      return {};
    },
    components: {
      navBar,
    },
  };
</script>
